/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_CaptionInputs */

const en_mascot_caption = /** @type {(inputs: Mascot_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A friend at every step.`)
};

const id_mascot_caption = /** @type {(inputs: Mascot_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teman di setiap langkah.`)
};

/**
* | output |
* | --- |
* | "A friend at every step." |
*
* @param {Mascot_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mascot_caption = /** @type {((inputs?: Mascot_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mascot_caption(inputs)
	return en_mascot_caption(inputs)
});